export default {"src":"/_next/static/image/public/icons/mail.84b3b24422b6bfe8ed7164b6d05172f5.svg","height":17,"width":21};